import React from "react"
import { GENDER_OPTIONS } from "./aiTargetingConstants"

export default function GenderSelector({ value, onChange }) {
  return (
    <div className="ai-targeting-form__field">
      <div className="ai-targeting-form__field-header">
        <div className="ai-targeting-form__field-icon">
          <i className="fas fa-venus-mars"></i>
        </div>
        <label className="ai-targeting-form__field-label">Genre ciblé</label>
      </div>
      <div className="ai-targeting-form__gender-grid">
        {GENDER_OPTIONS.map((option) => (
          <button
            key={option.label}
            type="button"
            className={`ai-targeting-form__gender-option ${value === option.value ? "ai-targeting-form__gender-option--active" : ""
              }`}
            onClick={() => onChange(option.value)}
          >
            <i className={option.icon}></i>
            <span>{option.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
